export default "__VITE_ASSET__BHkMGP1J__"